const wp = (widthPercent: string | number): string | number => {
  return `${widthPercent}%`;
};

const hp = (heightPercent: string | number): string => {
  return `${heightPercent}%`;
};

export { wp, hp };
